<template>
  <el-dialog
    :title="title"
    width="600px"
    @close="handleHide"
    v-model="dialogVisible"
    :modal="true"
    :close-on-click-modal="false"
  >
    <el-alert
      :title="message"
      type="error"
      :closable="false"
      v-if="message"
      style="margin-top: -20px; margin-bottom: 20px"
    ></el-alert>

    <div style="padding-right: 20px">
      <el-form :model="form" label-width="100px">
        <el-form-item label="群组名称：">
          <el-input
            v-model="form.groupname"
            style="width: 100%"
            placeholder="请输入群组名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="关联应用：">
          <el-select
            v-model="form.appids"
            :multiple="true"
            :filterable="true"
            :default-first-option="true"
            placeholder="请选择关联应用"
            style="width: 100%"
          >
            <AppSelectOptions :apps="projectApps" />
          </el-select>
        </el-form-item>
        <el-form-item label="组员：">
          <el-select
            v-model="form.members"
            multiple
            filterable
            remote
            reserve-keyword
            placeholder="请输入组员"
            :remote-method="remoteMethod"
            :loading="loading"
            style="width: 100%"
          >
            <el-option
              v-for="item in options"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div style="padding-right: 40px">
        <el-button @click="handleHide">取 消</el-button>
        <el-button
          type="primary"
          :disabled="form.groupname == ''"
          @click="handleSubmit"
          :loading="posting"
          >确 定
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  apiAddTestGroup,
  apiGetKoaUserList,
  apiModifyTestGroup,
} from "@/Api/AppApi";
import { useProjectStore } from "@/Store/ProjectStore";
import { storeToRefs } from "pinia";
import {
  ref,
  defineProps,
  defineExpose,
  reactive,
  getCurrentInstance,
  onMounted,
  defineEmits,
} from "vue";
import AppSelectOptions from "@/Components/AppDetail/Detail/Info/AppSelectOptions.vue";

const props = defineProps({
  title: String,
  type: String, // new/edit
});
defineExpose({ show });
const emit = defineEmits(["submit-success"]);

const { appContext } = getCurrentInstance();
const $message = appContext.config.globalProperties.$message;

const projectStore = useProjectStore();
const { projectApps, currentProjectId, testUsers } = storeToRefs(projectStore);

const koaUserList = ref([]);
async function getKoaUserList() {
  const res = await apiGetKoaUserList();
  if (res.code === 0) {
    koaUserList.value = res.data || [];
  } else {
    $message.error(res.message);
  }
}
onMounted(() => {
  getKoaUserList();
});

const dialogVisible = ref(false);
const form = reactive({
  groupid: null,
  groupname: "",
  appids: [],
  members: [],
});
function show(data) {
  if (data) {
    for (const key in data) {
      form[key] = data[key];
    }
  }

  dialogVisible.value = true;
}

const message = ref("");
function handleHide() {
  dialogVisible.value = false;
  message.value = "";

  form.groupid = null;
  form.groupname = "";
  form.appids = [];
  form.members = [];
}

const options = ref([]);
const loading = ref(false);
function remoteMethod(query) {
  if (query !== "") {
    loading.value = true;
    const q = query.toLowerCase();
    options.value = koaUserList.value.filter((item) =>
      item.toLowerCase().includes(q)
    );
    loading.value = false;
  } else {
    options.value = [];
  }
}

const posting = ref(false);
async function handleSubmit() {
  const postData = {
    projectid: currentProjectId.value,
    groupname: form.groupname.trim(),
    appids: form.appids,
    members: form.members,
  };

  if (props.type === "edit") {
    postData.groupid = form.groupid;
  }

  const api = props.type === "new" ? apiAddTestGroup : apiModifyTestGroup;
  posting.value = true;
  const res = await api(postData);
  posting.value = false;
  if (res.code === 0) {
    handleHide();
    emit("submit-success");
  } else {
    message.value = res.message;
  }
}
</script>
